import { mdiDoorClosed } from '@mdi/js'

export default [
  {
    title: 'Menu.Projects',
    icon: mdiDoorClosed,
    resource: 'all',
    action: 'can_see_projects_menu',
    children: [
      {
        to: 'projects',
        title: 'Projects.Pages.Menu',
        resource: 'all',
        action: 'can_see_projects_menu',
      },
    ],
  },
]
